import {Component,OnInit, ElementRef, ViewChild} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CommonApiService } from '../../common-api.service';
import { JobOrder } from './joborder.interface';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SnackbarService } from '../../snackbar.service';
import { environment } from "../../../../environments/environment"
import { MatTable } from '@angular/material/table';
import { JobOrderLine } from './joborderline.interface';
import { JobOrderLineComponent } from './order-line.component';
import { MatSelect } from '@angular/material/select';
import { tap, filter, finalize } from 'rxjs/operators';
import { CommonDropdownService } from '../../common-dropdown.service';
import { DateStorageService } from '../../date-storage.service';

interface Job_Type {
    value: string;
    viewValue: string;
}
interface Procedure {
    value: string;
    viewValue: string;
}
@Component({
  selector: 'app-joborder.form',
  templateUrl: './joborder.form.component.html',
  styleUrls: ['./joborder.form.component.css']
})



export class JobOrderFormComponent implements OnInit {
      
    
    @ViewChild('remarkInput') remarkInput: ElementRef<HTMLInputElement>;
    @ViewChild('product_lines') product_lines: MatTable<any>;
    @ViewChild('doctor_id', { static: false }) doctor_id: MatSelect;// for dropdown
    @ViewChild('category_id', { static: false }) category_id: MatSelect;// for dropdown
  
    constructor(
        private route: ActivatedRoute,
        private api: CommonApiService,
        private router: Router,
        public dialog: MatDialog,
        private snackbar: SnackbarService,
        private dropdownService: CommonDropdownService,
        private dateStorageService: DateStorageService

    ) {}

    procedure: Procedure[] = [
        {value: 'digital', viewValue: 'Digital'},
        {value: 'physical', viewValue: 'Physical'},
    ];

    job_type: Job_Type[] = [
        {value: 'regular', viewValue: 'Regular'},
        {value: 'repair', viewValue: 'Repair'},
        {value: 'repeat', viewValue: 'Repeat'},
    ];
    
    public model = 'joborder';
    public selectedJobType: string;
    public selectedProcedure: string;
    public joborder = {} as JobOrder;
    public fileUploadUrl = '';

    public dialogResult: any;

    public allComments: any[] = [];
    public allJobPrefix: any[] = [];
    public selectedJobPrefixObject: any[] = [];
    public selectedJobPrefix: number;

    doctorSearchPage = 0;
    allDoctorsCount = 0
    public allDoctors: any[] = [];
    public selectedDoctor: number;
    public selectedDoctorObject: any[] = [];
    
    categorySearchPage = 0;
    allCategoriesCount = 0
    public allCategories: any[] = [];
    public selectedCategoryObject: any[] = [];
    public selectedCategory: number;
    
    public jobProcesses: any[] = [];
    public selectedRepairProcess: number;

    public allRemarks: any[] = [];
    public filteredRemarks = this.allRemarks;
    public selectedRemark: number;
    
    public allProducts: any[] = [];
    
    result: string;
    selectable = true;
    removable = true;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    remarkCtrl = new FormControl();
    remarks: string[] = [];
    isFormDisabled = true;
    isShowing = false;
    onSaveDisable = false;
    productLinesSource: any = []
    orderLineDisplayedColumns: string[] = ['product_name', 'delete'];

    restoration_type:any =
    [
        'Joint Crowns',
        'Separate Crown',
        'Bridge'
    ];
    
    enclosed_cases:any =
    [
        'Impression Upper',
        'Impression Lower',
        'Bite',
        'Photos',
        'Model Upper',
        'Model Lower',
        'Others' 
    ];

    unit_cases:any =
    [
        'Lab Analog',
        'Screw',
        'Impression post',
        'Abutment',
        'Other'
    ];
      
    enclosed_cases_selected:any =[];
    restoration_type_selected:any =[];

    public jobFormGroup: FormGroup;
    public dupicateJob: boolean = false;

    minDate: Date | null = new Date();
    maxDate: Date | null = new Date();

    ngOnInit() {

        let jobId = this.route.snapshot.params.id
        if (jobId === 'create') {
            this.isFormDisabled = false;
            this.selectedProcedure = 'physical';
            this.selectedJobType = 'regular';
            this.onLoadPrefixList();
        } else {
            this.getJobOrder(Number(jobId));
        }

        this.api.getAll('remark').subscribe(res => {
            this.allRemarks = res;
            this.filteredRemarks = res;
        })

        this.onLoadCategoryList();
        this.onLoadDoctorList();

        this.minDate = this.dateStorageService.getDateFromLocalStorage('fy_start_date')
        this.maxDate = this.dateStorageService.getDateFromLocalStorage('fy_end_date')
    }

    docUpload(event: any) {
        console.log(event)
        if (event.ok) {
            this.joborder.filename = event.body.filename
        }
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files?.length || !this.fileUploadUrl) return;
        const file = input.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.api.upload(this.fileUploadUrl, formData).subscribe({
            next: (res: any) => {
                if (res?.filename) {
                    this.joborder.filename = res.filename;
                }
            },
            error: (err: any) => this.snackbar.error(err?.error?.message || 'Upload failed')
        });
    }

    //api call to bring search values in dropdown and also the selected value in dropdown is displayed
    // Note: include inactive doctors so users can see historical doctors on existing
    // jobs. They are rendered disabled in the template.
    onDoctorKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        const params: any = { active: 'all' };
        if (value) {
            params.searchValue = value;
        } else {
            params.pageIndex = 0;
            params.pageSize = environment.defaultPageSizeOnScroll;
        }
        this.api.postAll('doctor/list/display', params).subscribe((res: any) => {
            const newItems = (res.items || []).filter(
                (entity: any) => entity.id !== this.selectedDoctorObject[0]?.id
            );
            this.allDoctors = this.selectedDoctorObject[0]
                ? [this.selectedDoctorObject[0], ...newItems]
                : newItems;
            this.doctorSearchPage = value ? 1 : 1;
        });
    }

    // On scroll of dropdown api call to fetch next records
    onDoctorScroll(event:any) {

        if (!this.doctor_id?.panel || !this.doctor_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.doctor_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.doctor_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.doctor_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.doctor_id.panel.nativeElement.offsetHeight)
                    ){
                    let doctorparams = {
                        'pageIndex': this.doctorSearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll,
                        'active': 'all'
                    }
                    
                    if (this.allDoctors.length >= this.allDoctorsCount) {
                        return;
                    }
                    this.api.postAll('doctor/list/display', doctorparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedDoctorObject[0]?.id);
                        this.allDoctors.push(...res.items);
                    });
                    this.doctorSearchPage++;// send page number for fetching the records
                }
            });
        }
    }

    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadDoctorList() {
        let params = {
            'pageIndex': this.doctorSearchPage,
            'pageSize': environment.defaultPageSizeOnScroll,
            'active': 'all'
        }

        this.api.postAll('doctor/list/display', params).pipe(
            tap((res: any) => {
                this.allDoctors.push(...res.items);
                this.allDoctorsCount = res.rowCount
            }),
            filter(() => this.selectedDoctorObject.length !== 0),
            tap(() => {
              const selectedDoctorId = this.selectedDoctorObject[0].id;
              this.allDoctors = this.allDoctors.filter(doctor => doctor.id !== selectedDoctorId);
              this.allDoctors.unshift(this.selectedDoctorObject[0]);
              
            }),
            finalize(() => this.doctorSearchPage++)
        ).subscribe();
    }

    onLoadPrefixList() {

        this.api.callRoute('joborder', '/job_prefix', null).pipe(
            tap((res: any) => {
                this.allJobPrefix = res;
            }),
            filter(() => this.selectedJobPrefixObject.length !== 0),
            tap(() => {
              const selectedJobPrefixId = this.selectedDoctorObject[0].id;
              this.allJobPrefix = this.allJobPrefix.filter(prefix => prefix.id !== selectedJobPrefixId);
              this.allJobPrefix.unshift(this.selectedJobPrefixObject[0]);
              
            }),
        ).subscribe();
    }

    //api call to bring search values in dropdown and also the selected value in dropdown is displayed
    onCategoryKey(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.dropdownService.updateSearchResults(value, 'category', this.allCategories, this.selectedCategoryObject, 'categorySearchPage')
          .subscribe((result: { entityList: any[], pageVariable: number }) => {
            this.allCategories = result.entityList;
            this.categorySearchPage = result.pageVariable;
        });
    }

    // On scroll of dropdown api call to fetch next records
    onCategoryScroll(event:any) {

        if (!this.category_id?.panel || !this.category_id?.panel.nativeElement) {
            // Panel or nativeElement is not available, return or handle the situation accordingly.
            return;
        }
        if (event) {
            this.category_id.panel.nativeElement.addEventListener(
            'scroll',   
            (event: any) => {
                const tolerance = 10
                if (
                    Math.floor(this.category_id.panel.nativeElement.scrollTop) + tolerance >= 
                    Math.floor(this.category_id.panel.nativeElement.scrollHeight) -
                    Math.floor(this.category_id.panel.nativeElement.offsetHeight)
                    ){
                    let categoryparams = {
                        'pageIndex': this.categorySearchPage,
                        'pageSize': environment.defaultPageSizeOnScroll
                    }
                    
                    if (this.allCategories.length >= this.allCategoriesCount) {
                        return;
                    }
                    this.api.postAll('category/list/display', categoryparams).subscribe((res: any) =>{
                        res.items = res.items.filter((entity: any) => entity.id !== this.selectedCategoryObject[0]?.id);
                        this.allCategories.push(...res.items);
                    });
                    this.categorySearchPage++;// send page number for fetching the records
                }
            });
        }
    }

    // On load of component default pageSize for dropdown to load and also set selected value if present
    onLoadCategoryList() {
        let params = {
            'pageIndex': this.categorySearchPage,
            'pageSize': environment.defaultPageSizeOnScroll
        }

        this.api.postAll('category/list/display', params).pipe(
            tap((res: any) => {
                this.allCategories.push(...res.items);
                this.allCategoriesCount = res.rowCount
            }),
            filter(() => this.selectedCategoryObject.length !== 0),
            tap(() => {
              const selectedCategoryId = this.selectedCategoryObject[0].id;
              this.allCategories = this.allCategories.filter(category => category.id !== selectedCategoryId);
              this.allCategories.unshift(this.selectedCategoryObject[0]);
              
            }),
            finalize(() => this.categorySearchPage++)
        ).subscribe();
    }

    onCategoryChange(event:any) {
        this.api.get('product/category', this.selectedCategory).subscribe(
			(products: any) => {
				if (products) {
					this.allProducts = products
                    this.productLinesSource = [];
				}
                this.joborder.order_lines = this.productLinesSource
                this.product_lines.renderRows();
			}
		)
    }
  
    add(event: MatChipInputEvent): void {
      const value = (event.value || '').trim();
      // Add our remark
        if (value) {
            this.remarks.push(value);
        }
        // Clear the input value
        event.chipInput!.clear();
        this.remarkCtrl.setValue(null);

    }
  
    remove(remark: string): void {
      const index = this.remarks.indexOf(remark);
        
        if (index >= 0) {
            this.remarks.splice(index, 1);
        }
        var textarea = <HTMLInputElement>document.getElementById("remarks_section");
        textarea.value = this.remarks.join("\n");
    }
  
    selected(event: MatAutocompleteSelectedEvent): void {
        // Focus out (blur) the input element
        this.remarkInput.nativeElement.blur();
    
        this.remarks.push(event.option.viewValue);
        this.remarkInput.nativeElement.value = '';
        this.remarkCtrl.setValue(null);
        this.remarks = this.remarks
        var description = event.option.value.description

        var textarea = <HTMLInputElement>document.getElementById("remarks_section");
        textarea.value += description + "\n";
        this.joborder.remarks_section =textarea.value;
    }
  
    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.filteredRemarks.filter(fruit => fruit.toLowerCase().includes(filterValue));
    }

    enclosedCaseChkBox(e:any){
        let checkboxValue = e.source.value;
        if(e.checked){
            this.enclosed_cases_selected.push(checkboxValue);
        }
        else{
            let  k = 0;
            var len = this.enclosed_cases_selected.length;
            for (k = 0; k < len; k = k + 1) {
                if (this.enclosed_cases_selected[k] === checkboxValue) {
                    this.enclosed_cases_selected.splice(k, 1);
                }
            }
        }
    }

    restoTypeChkBox(e:any){
        let checkboxValue = e.source.value;
        if(e.checked){
            this.restoration_type_selected.push(checkboxValue);
        }
        else{
            let  k = 0;
            var len = this.restoration_type_selected.length;
            for (k = 0; k < len; k = k + 1) {
                if (this.restoration_type_selected[k] === checkboxValue) {
                    this.restoration_type_selected.splice(k, 1);
                }
            }
        }
    }

    getJobOrder(jobId:number) {
        this.api.get(this.model, jobId).subscribe(
            (data: any) => {
                if (data) {
                    this.joborder = data;
                    this.productLinesSource = data.order_lines ? data.order_lines : []
                    this.enclosed_cases_selected = data.enclosed_with_case;
                    this.restoration_type_selected = data.restoration_type;
                    this.selectedJobType = data.job_type;
                    this.selectedProcedure = data.procedure;

                    if(data.doctor){
                        this.selectedDoctor = data.doctor.id;
                        this.allDoctors = this.allDoctors.filter(doctor => doctor.id !== data.doctor.id);
                        this.allDoctors.push(data.doctor) // insert specific selected doctor into the dropdown list
                        this.selectedDoctorObject.push(data.doctor)
                    }

                    if(data.category){
                        this.selectedCategory = data.category.id;
                        this.allCategories = this.allCategories.filter(category => category.id !== data.category.id);
                        this.allCategories.push(data.category) // insert specific selected doctor into the dropdown list
                        this.selectedCategoryObject.push(data.category)

                        if (this.selectedCategoryObject[0].id != 0) {
                            
                            this.api.get('product/category', this.selectedCategoryObject[0].id).subscribe(
                                (products: any) => {
                                    if (products) {
                                        this.allProducts = products
                                    }
                                }
                            )
                        }
                    }

                    this.api.callRoute('joborder', '/comments', {'job_id': data.id}).subscribe(
                        (data: any) => {
                            if (data) {
                                this.allComments = data;
                            }   
                        },
                        error => {
                            this.snackbar.error(error.message)
                        }
                    );

                    this.fileUploadUrl = `${this.model}/${this.joborder.id}/uploader`
                }
            }
        );
    }

    addProductLine(order_line: JobOrderLine, activeAddress: any) {
        var replaced = false;
        for (let i = 0; i < this.productLinesSource.length; i++) {
            if (this.productLinesSource[i] == activeAddress) {
                this.productLinesSource[i] = order_line
                replaced = true
                break
            }
        }
        if (!replaced) {
            this.productLinesSource.push(order_line);
        }
        this.joborder.order_lines = this.productLinesSource
        this.product_lines.renderRows();
    }

    confirmDialog(action:any): void {
        var message = '';
        var title = '';
        var repairJob = false
        if (this.joborder.job_type == 'repair' && this.joborder.status == 'draft') {
            repairJob = true
        }
        var hold_or_release = false
        if(action == 'schedule') {
            message = `Are you sure you want to schedule this job for production?`
            title = 'Confirm Job Schedule'
            repairJob = repairJob
        } else if (action == 'hold') {
            message = `Are you sure you want to hold this job?`
            title = 'Confirm Job Hold'
            hold_or_release = true
        } else if (action == 'release') {
            message = `Are you sure you want to release this job?`
            title = 'Confirm Job Release'
            hold_or_release = true
        } else if (action == 'cancel') {
            message = `Are you sure you want to cancel this job?`
            title = 'Confirm Job Cancel'
        } else if (action == 'repeat') {
            message = `Are you sure you want to repeat this job?`
            title = 'Confirm Job Repeat'
            hold_or_release = true
        } else if (action == 'repair') {
            message = `Are you sure you want to repair this job?`
            title = 'Confirm Job Repair'
        } else if (action == 'draft') {
            message = `Are you sure you want to save as draft?`
            title = 'Confirm Job Draft'
        }
	
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title:   title,
			message: message,
            job_id:  this.joborder.id,
            repairJob : repairJob,
            passFlagToDisable: this.isFormDisabled,
            hold_or_release: hold_or_release,
            comment_required: action !== 'repeat'
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe((dialogRes:any) => {
            
			this.dialogResult = dialogRes;
            
			if (this.dialogResult) {
                if (action == 'repair') {
                    this.repairJobOrder(this.dialogResult.repairProcess);
                } else if (action == 'repeat') {
                    this.repeatJobOrder(this.dialogResult.comment_description);
                }
                else if (action == 'hold' || action == 'release') {
                    this.hold_or_release_job(action, this.dialogResult.comment_description);
                } else {
                    this.jobOrderAction(action, this.dialogResult.repairProcess);
                }
			}
		});
	}

    printJobOrder(): void {
        const printWindow = window.open('/api/joborder/' + this.joborder.id + '/download');
        if (printWindow) {
          printWindow.print();
        }
      }
      

    repairJobOrder (process_id: number) {
        this.api.callRoute('joborder', `/create_repair_order`, {'parent_id': this.joborder.id,'repair_process_ids': process_id}).subscribe(
            (data: any) => {
                if (data.status) {
                    this.snackbar.success("Job Repaired successfully")
                    this.redirectTo(`joborder`);
                }
                else {
                    this.snackbar.info(data.message)
                }
            },
            error => {
                console.log(error)
            }
        );
    }

    repeatJobOrder (remark?: string){
        this.api.callRoute('joborder', `/create_repeat_order`, {'parent_id': this.joborder.id, 'remark': remark}).subscribe(
            (data: any) => {
                if (data.status) {
                    this.snackbar.success("Job Repeated successfully")
                    this.redirectTo(`joborder`);
                }
                else {
                    this.snackbar.info(data.message)
                }
            },
            error => {
                console.log(error)
            }
        );
    }

    hold_or_release_job(action:any, comment:any){
        this.api.callRoute('joborder', `/${action}`, {'job_no': this.joborder.job_no, 'job_id': this.joborder.id, 'comment': comment}).subscribe(
            (resp) => {
                if (resp.status != 'error') {
                    if ( action == 'hold') {
                        this.snackbar.info('Job order status changed to hold!');
                    } else if ( action == 'release') {
                        this.snackbar.info('Job order status changed to release!');
                    } 
                    this.redirectTo(`joborder`);
                }
                else {
                    this.snackbar.info(resp.message)
                }
            },
            error => {
                console.log(error)
            }
        );
    }

    openDialog(activeLine: any) {
        if(this.selectedProcedure == undefined){
            this.snackbar.warning("Please select procedure.");
            return;
        }
        if(this.selectedCategory == undefined){
            this.snackbar.warning("Please select category name.");
            return;
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '900px';
        dialogConfig.maxWidth = '95vw';
        dialogConfig.maxHeight = '90vh';
        dialogConfig.data = {
            uid: activeLine.id,
            jobId: this.joborder.id,
            passFlagToDisable: this.isFormDisabled,//send flag
            orderLine: activeLine,
            allProducts: this.allProducts,
        }
        const dialogRef = this.dialog.open(JobOrderLineComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.addProductLine(result.orderLine, activeLine);
            }
        });

    }

    deleteLine(index: any) {
        if(this.isFormDisabled){
            return;
        }
        this.productLinesSource.splice(index, 1)
        this.joborder.order_lines = this.productLinesSource     
        this.product_lines.renderRows();
    }    

    jobOrderAction(action: any, process_ids?: any) {
        if(action == ''){
            this.snackbar.error("please retry again")
            return;
        }

        const data = {
            'process_ids': process_ids
        }
        console.log(data)
		this.api.callRoute('joborder', `/${action}/${this.joborder.id}`, data).subscribe(
            (resp) => {
                if (resp.status != 'error') {
                    if (action == 'schedule') {
                        this.snackbar.success('Job order Scheduled Successfully!');
                    } else if ( action == 'cancel') {
                        this.snackbar.info('Job order status changed to cancel!');
                    } else if ( action == 'repeat') {
                        this.snackbar.success('Job order repeated successfully!');
                    } else if ( action == 'repair') {
                        this.snackbar.info('Job order sent for repair!');
                    } else if ( action == 'draft') {
                        this.snackbar.success('Job order saved as draft!');
                    }   
                    this.redirectTo(`joborder`);
                }
                else {
                    this.snackbar.info(resp.message)
                }
            },
            error => {
                console.log(error)
            }
        );
	}
    

    save(formValid:any) {
        if(formValid == false){
            this.snackbar.warning("Please fill mandatory fields.");
            return;
        }
        if(this.selectedJobType == undefined){
            this.snackbar.warning("Please select job type.");
            return;
        }
        if(this.selectedProcedure == undefined){
            this.snackbar.warning("Please select procedure.");
            return;
        }
        if(this.selectedDoctor == undefined){
            this.snackbar.warning("Please select doctor name.");
            return;
        }
        if(this.selectedCategory == undefined){
            this.snackbar.warning("Please select category name.");
            return;
        }
        if(this.joborder.order_lines == undefined){
            this.snackbar.warning("Please add atleast one product.");
            return;
        }
        if(this.joborder.order_lines.length <= 0){
            this.snackbar.warning("Please add atleast one product.");
            return;
        }
        
        this.onSaveDisable = true;
        
        this.joborder.enclosed_with_case = this.enclosed_cases_selected;
        this.joborder.restoration_type = this.restoration_type_selected;
        this.joborder.doctor_id = this.selectedDoctor;
        this.joborder.category_id = this.selectedCategory;
        this.joborder.job_type = this.selectedJobType;
        this.joborder.doc_prefix_id = this.selectedJobPrefix;
        this.joborder.procedure = this.selectedProcedure;
       
        this.api.createUpdate(this.model, this.joborder).subscribe(
            (data:any) => {
                if (data) {
                    this.joborder = data;  
                    // changing previously selected value as blank and adding latest selected value 
                    if (data.doctor) {
                    this.dropdownService.addToSelectedObjectArray(this.selectedDoctorObject, data.doctor);
                    }
                    
                    if (data.category) {
                        this.dropdownService.addToSelectedObjectArray(this.selectedCategoryObject, data.category);
                    }

                    this.isFormDisabled = true;
                    this.snackbar.success('Saved Successfully!');
                    this.router.navigate([`/${this.model}/${data.id}`])
                    this.onSaveDisable = false;
                }
            },
            error => {
                this.snackbar.error(error.error.message)
                console.log(error)
                this.onSaveDisable = false;
            }
        );
    }

    edit(){
        this.isFormDisabled = false;
    }

    discardChanges(): void {
		const message = `Are you sure you want to discard the changes?`
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = {
			title: "Discard Changes",
			message: message
		}
		const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			// return true or false or undefined , hence we can handle the functionality on true and false likewise here
			if (this.result) {
                if(this.joborder.id){
                    this.isFormDisabled = true;
                    this.getJobOrder(this.joborder.id);
                }else{
                    this.router.navigate([`/joborder`]);
                }
			}
		});
	}

    create(){
        this.redirectTo('joborder/create');
    }

    checkJobDuplicate(){
        this.api.callRoute('joborder', `/check_duplicate`, {'job_no': this.joborder.job_no, 'job_id': this.joborder.id}).subscribe(
            (data: any) => {
                    if (data.success) {
                        this.dupicateJob = false;
                        return true;
                    }
                    else {
                        this.dupicateJob = true;
                        return false;
                    }
            }
        );
    }

    //redirects to the expected route
    //this function will redirect to a dummy route and quickly return to the destination route without the user realizing it.
    redirectTo(uri:string){  
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([uri]));
    }

    public checkError = (controlName: string, errorName: string) => {
        return this.jobFormGroup.controls[controlName].hasError(errorName);}

}
